import { useState, useCallback, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import { useFolderActions } from '../../actions/FolderActions';
import { isValidName } from '../../utils/folders';

export default function EditFolderNameDialog({ open, onClose, data }) {
  const { t } = useTranslation();
  const { folder } = data;
  const [name, setName] = useState(folder?.name);
  const { updateFolderAsync } = useFolderActions(folder?.id);

  useEffect(() => {
    setName(folder?.name);
  }, [folder?.name]);

  const handleClose = useCallback(() => {
    setName(folder?.name);
    onClose();
  }, [folder?.name, onClose]);

  const handleSave = useCallback(async () => {
    await updateFolderAsync({ name });
    setName('');
    onClose();
  }, [updateFolderAsync, name, onClose]);

  const isValidFolderName = useMemo(() => isValidName(name), [name]);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{t('Redigera namn')}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label={t('Namn')}
          type="text"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
          size="small"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t('Avbryt')}</Button>
        <Button onClick={handleSave} disabled={!isValidFolderName}>
          {t('Spara')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
